<template>
  <div id="app">
    <router-view/>
    <!-- AI助理组件，仅在用户已登录时显示 -->
    <ai-assistant v-if="isLoggedIn" />
  </div>
</template>

<script>
import LoginService from './api/LoginService';
import { CachePocily } from './common/Cache';
import { ECache } from './enum/ECache';
import CACHE_KEY from './constant/cacheKey';
import RootType from './store/mutation-types';
import AIAssistant from './components/ai-assistant/AIAssistant.vue';

export default {
  name: 'app',
  components: {
    AIAssistant
  },
  data() {
    return {
      loginService: null,
      cache: null,
      isLoggedIn: false
    }
  },
  created() {
    this.loginService = LoginService.getInstance();
    this.cache = CachePocily.getInstance(ECache.LocCache);
  },
  mounted() {
    this.checkLoginStatus();
    // 如果已登录，获取业务配置
    const loginInfo = this.cache.getData(CACHE_KEY.LOGIN);
    if (loginInfo && loginInfo.userInfo) {
      const userInfo = JSON.parse(loginInfo.userInfo);
      if (userInfo.token) {
        this.loginService.getBusinessConfigs().then((response) => {
          if(response.data && response.data.data) {
            // 存储所有配置
            this.$store.commit(RootType.UPDATE_ALL_SETTING_SCALE, response.data.data);
          } else {
            // 如果没有配置数据，设置默认值
            this.$store.commit(RootType.UPDATE_ALL_SETTING_SCALE, []);
          }
        }).catch((error) => {
          console.error('获取业务配置失败:', error);
          this.$store.commit(RootType.UPDATE_ALL_SETTING_SCALE, []);
        });
      }
    }
  },
  methods: {
    checkLoginStatus() {
      const loginInfo = this.cache.getData(CACHE_KEY.LOGIN);
      console.log('AI助理调试 - 登录信息:', loginInfo);

      if (loginInfo && loginInfo.userInfo) {
        const userInfo = JSON.parse(loginInfo.userInfo);
        console.log('AI助理调试 - 用户信息:', userInfo);
        this.isLoggedIn = !!(userInfo.token);
      } else {
        this.isLoggedIn = false;
      }

      console.log('AI助理调试 - 登录状态:', this.isLoggedIn);
    }
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color:#EDEFF5;
}
a[title=站长统计]{
  display: none;
}
</style>
